export default "__VITE_ASSET__B5pP$o7z__"